<template>
  <el-container></el-container>
</template>
<script>
export default {
  name: 'OAuth2',
  data () {
    return {}
  },
  mounted () {
    let query = this.$route.query
    let newUrl = 'https://us.roompai.com/api/authorizedLoginUs?domain=' + query.domain + '&operation=' + query.operation + '&' + window.location.hash.substr(1)
    console.log(newUrl)
    window.location.href = newUrl
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/module/OAuth2.vue